import React, { PureComponent } from 'react'
import {
  TimeRemainingWrapper,
  TimeSlot,
} from './TimeRemaining.elements'

const SECONDS_IN_A_DAY = 86400 // 24 * 60 * 60
const SECONDS_IN_AN_HOUR = 3600 // 60 * 60
const SECONDS_IN_A_MIN = 60

type Props = {
  endDate: Date
  onFinish?: () => void
}

type State = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export class TimeRemaining extends PureComponent<Props> {
  state: State = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  }

  interval: NodeJS.Timeout

  componentDidMount() {
    this.interval = setInterval(this.advanceTime, 1000)
  }

  componentWillUnmount() {
    this.stop()
  }

  advanceTime = () => {
    const { onFinish } = this.props
    const date = this.calculateCountdown()

    if (date) {
      this.setState(date)
    } else {
      this.stop()
      onFinish && onFinish()
    }
  }

  calculateCountdown = (): State | null => {
    const { endDate } = this.props

    const parsedEndDate = Date.parse(new Date(endDate).toString())
    const parsedNow = Date.parse(new Date().toString())
    let timeDiff = (parsedEndDate - parsedNow) / 1000

    if (timeDiff <= 0) { // Countdown reached.
      return null
    }

    const timeLeft: State = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    }

    if (timeDiff >= SECONDS_IN_A_DAY) {
      timeLeft.days = Math.floor(timeDiff / SECONDS_IN_A_DAY)
      timeDiff -= timeLeft.days * SECONDS_IN_A_DAY
    }

    if (timeDiff >= SECONDS_IN_AN_HOUR) {
      timeLeft.hours = Math.floor(timeDiff / SECONDS_IN_AN_HOUR)
      timeDiff -= timeLeft.hours * SECONDS_IN_AN_HOUR
    }

    if (timeDiff >= SECONDS_IN_A_MIN) {
      timeLeft.minutes = Math.floor(timeDiff / SECONDS_IN_A_MIN)
      timeDiff -= timeLeft.minutes * SECONDS_IN_A_MIN
    }

    timeLeft.seconds = timeDiff

    return timeLeft
  }

  stop() {
    clearInterval(this.interval)
  }

  render () {
    const { days, hours, minutes, seconds } = this.state

    return (
      <TimeRemainingWrapper>
        <TimeSlot>
          {days}
          d
        </TimeSlot>
        <TimeSlot>
          {hours}
          h
        </TimeSlot>
        <TimeSlot>
          {minutes}
          m
        </TimeSlot>
        <TimeSlot>
          {seconds}
          s
        </TimeSlot>
      </TimeRemainingWrapper>
    )
  }
}
